import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiselectComponent from "../components/MultiselectComponent";
import {
  getOutputColumnsData,
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
  getMappings,
} from "../store/workspaceSlice";
import { sortObjectByKeys } from "../utils";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import CheckBox from "../components/CheckBox";
import { showAddedRulesToast, rulesProperties } from "../helpers";
const allowedRules = [
  1, // 1:GroupBy rule
  2, // 2:FindRule
];
const Toggle = ({ checked, onChange }) => (
  <button
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none ${checked ? "bg-blue-600" : "bg-slate-300"}`}
  >
    <span
      className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-200 ${checked ? "translate-x-5" : "translate-x-0"}`}
    />
  </button>
);
const initialObjectProperties = {
  appliedRule: 10,
  aggregateMappings: {},
  inputColumns: [],
  outputColumns: [],
  selectedAction: "",
  calculateSumByDate: false,
  useOutputOf: null,
};

const Aggregate = () => {
  const dispatch = useDispatch();
  const [customColumn, setCustomColumn] = useState(initialObjectProperties);
  const [selectInputcols, setselectInputcols] = useState();
  const [selectOutputCols, setselectOutputCols] = useState();
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag); // unsaved changes flag
  const currentMaps = useSelector(getMappings);

  useEffect(() => {
    if (state?.type === "Aggregate") {
      setCustomColumn({
        ...state.data,
      });
      setselectInputcols(
        state.data.inputColumns.map((item) => ({
          label: item,
          value: item,
        })),
      );
      setselectOutputCols(
        state.data.outputColumns.map((item) => ({
          label: item,
          value: item,
        })),
      );
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const handlesetselectInputcols = (selectedOptions) => {
    setselectInputcols(selectedOptions);
    const selectedValues = selectedOptions.map((sel) => sel.value);
    setCustomColumn({
      ...customColumn,
      inputColumns: selectedValues, // Selected column keys
    });

    helperFunction();
  };

  const handlesetselectOutputCols = (selectedOptions) => {
    setselectOutputCols(selectedOptions);
    setCustomColumn({
      ...customColumn,
      outputColumns: selectedOptions.map((sel) => sel.value),
    });
  };

  const handleOnChange = (e) => {
    setCustomColumn((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
    helperFunction();
  };

  const helperFunction = () => {
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    const cleanedMappings = Object.fromEntries(
      Object.entries(customColumn?.aggregateMappings).filter(([key]) =>
        customColumn?.inputColumns.includes(key),
      ),
    );

    const updatedAggregateObject = {
      ...customColumn,
      aggregateMappings: sortObjectByKeys(cleanedMappings), // Sort the object by keys
    };

    dispatch(
      saveAsMappings({
        ...updatedAggregateObject,
      }),
    );

    showAddedRulesToast(
      customColumn.appliedRule,
      isInLocalEditMode ? "Updated" : "added",
    ); // Show toast notification
    reset();
  };

  const reset = () => {
    setCustomColumn(initialObjectProperties);
    setselectInputcols("");
    setselectOutputCols("");
    setIsInLocalEditMode(false);
  };

  return (
    <>
      <div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-4 p-2">
        <MultiselectComponent
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          selectedOptions={selectInputcols}
          handleSetSelect={handlesetselectInputcols} // Handle the selection change
          label={"Select Input Columns"}
          required={true}
        />
        <MultiselectComponent
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          selectedOptions={selectOutputCols}
          handleSetSelect={handlesetselectOutputCols} // Handle the selection change
          label={"Select Output Columns"}
          required={true}
        />{" "}
        {customColumn.outputColumns.length === 1 &&
          customColumn.inputColumns.length >= 1 && (
            <div className="col-span-1 xl:col-span-2 flex justify-start items-end gap-x-8">
              <div className="min-h-10 flex">
                <CheckBox
                  name={"sameAsOutput"}
                  chkBoxText={"Same as output column"}
                  onChange={(e) => {
                    const allConditionsTrue =
                      customColumn.inputColumns.length > 0 &&
                      customColumn.outputColumns.length > 0;

                    if (e.target.checked && allConditionsTrue) {
                      setCustomColumn((prevState) => ({
                        ...prevState,
                        aggregateMappings: Object.fromEntries(
                          Object.values(prevState.inputColumns).map((key) => [
                            key,
                            customColumn.outputColumns[0],
                          ]),
                        ),
                      }));
                    }
                  }}
                />
              </div>
            </div>
          )}
        {customColumn.outputColumns?.length > 0 &&
          customColumn.inputColumns?.length > 0 && (
            <div className="col-span-1 xl:col-span-2 w-full">
              <label className="font-semibold">
                Map aggregated columns to output column
              </label>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
                {customColumn.inputColumns.map((column) => (
                  <DropDownMenu
                    key={column}
                    label={column}
                    name={column}
                    required={true}
                    value={customColumn.aggregateMappings[column] || ""}
                    options={customColumn.outputColumns.map((col) => ({
                      label: col,
                      value: col,
                    }))}
                    onChange={(e) => {
                      setCustomColumn((prev) => ({
                        ...prev,
                        aggregateMappings: {
                          ...prev.aggregateMappings,
                          [column]: e.target.value || "",
                        },
                      }));
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        <DropDownMenu
          label={"Select Action"}
          name="selectedAction"
          value={customColumn.selectedAction || ""}
          options={[
            { label: "Sum", value: "sum" },
            { label: "Average", value: "average" },
            { label: "Count", value: "count" },
            { label: "Max", value: "max" },
            { label: "Min", value: "min" },
          ]}
          onChange={handleOnChange}
          required={true}
        />
        <div className="col-span-1 xl:col-span-2 flex items-center gap-3">
          <Toggle
            checked={customColumn.calculateSumByDate}
            onChange={(val) => {
              setCustomColumn((prev) => ({
                ...prev,
                calculateSumByDate: val,
                useOutputOf: val ? prev.useOutputOf : null, // Reset useOutputOf if toggle is turned off
              }));
              helperFunction();
            }}
          />
          <label className="font-medium text-sm select-none">
            Perform Operation by Date
          </label>
        </div>
        {customColumn.calculateSumByDate && (
          <DropDownMenu
            label={"Use Output of previous Rule"}
            name="useOutputOf"
            value={customColumn.useOutputOf || ""}
            options={currentMaps
              .filter((item) => allowedRules.includes(item.appliedRule))
              .map((item) => ({
                label: `${item._id} :  ${
                  item.appliedRule
                    ? rulesProperties[item?.appliedRule].ruleName
                    : item.ruleName
                }`,
                value: parseInt(item._id),
              }))}
            onChange={handleOnChange}
            required={true}
          />
        )}
        <div className="mt-4 col-span-1 xl:col-span-2 flex gap-2">
          <Button
            btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
            handleOnClick={handleAddNewRule}
            disabled={
              customColumn.inputColumns.length === 0 ||
              customColumn.outputColumns.length === 0 ||
              customColumn.selectedAction === ""
            }
          />
          <Button btnType="cancel" btnText={"Reset"} handleOnClick={reset} />
        </div>
      </div>
    </>
  );
};

export default Aggregate;
